import React from 'react'
import ui from 'redux-ui'

import css from './style.scss'

let _tabsIdCounter = 0

export class Tabs extends React.Component {
  constructor (props) {
    super(props)
    this.idPrefix = `tabs-${_tabsIdCounter++}`
  }

  componentDidMount () { this.props.onSelectedIndex(0) }

  selectTab (index) {
    this.props.updateUI({ selectedIndex: index })
    if (this.props.onSelectedIndex) {
      this.props.onSelectedIndex(index)
    }
  }

  handleKeyDown (e, index) {
    const { sections } = this.props
    let next = null
    if (e.key === 'ArrowRight') {
      next = (index + 1) % sections.length
    } else if (e.key === 'ArrowLeft') {
      next = (index - 1 + sections.length) % sections.length
    } else if (e.key === 'Home') {
      next = 0
    } else if (e.key === 'End') {
      next = sections.length - 1
    }
    if (next !== null) {
      e.preventDefault()
      this.selectTab(next)
      const el = document.getElementById(`${this.idPrefix}-tab-${next}`)
      if (el) el.focus()
    }
  }

  render () {
    const { selectedIndex } = this.props.ui
    const panelId = `${this.idPrefix}-panel`
    return (
      <div>
        <div className={css.tabs}>
          <ul role='tablist'>
            {
              this.props.sections.map((section, index) => (
                <li
                  key={index}
                  id={`${this.idPrefix}-tab-${index}`}
                  role='tab'
                  aria-selected={selectedIndex === index}
                  aria-controls={panelId}
                  tabIndex={selectedIndex === index ? 0 : -1}
                  className={selectedIndex === index ? css.active : ''}
                  onClick={() => this.selectTab(index)}
                  onKeyDown={(e) => this.handleKeyDown(e, index)}
                >
                  {section.name}
                </li>
              ))
            }
          </ul>
        </div>
        <div
          id={panelId}
          role='tabpanel'
          aria-labelledby={`${this.idPrefix}-tab-${selectedIndex}`}
          tabIndex={0}
          className={css.body}
        >
          {this.props.sections[selectedIndex].component}
        </div>
      </div>
    )
  }
}

Tabs.propTypes = {
  onSelectedIndex: React.PropTypes.func,
  sections: React.PropTypes.arrayOf(React.PropTypes.shape({
    name: React.PropTypes.string,
    component: React.PropTypes.element
  })).isRequired,
  ui: React.PropTypes.object.isRequired,
  updateUI: React.PropTypes.func.isRequired
}

export default ui({
  state: {
    selectedIndex: 0
  }
})(Tabs)
